/**
 * Упрощаем реактивность локальных переменных и пропсов.
 * Изменение пропса - меняет локальную переменную и наоборот (через событие `update:имя пропса`).
 * В родителе можно использовать через  `:имя пропса.sync`
 *
 * для использования нужно только объявить `modelPropsEqualLocal`
 * например
 * ```
 * modelPropsEqualLocal: [
 *  ['firstName', 'firstNameLocal'],
 * ],
 * ```
 */
const useVModel = {
    data() {
        return {
            /**
             * @type {string[][]} - Каждый элемент списка - [пропс, локальная переменная][]
             */
            modelPropsEqualLocal: [],
            /**
             * внутреннее свойство
             */
            unwatchIds: [],
        };
    },
	created() {

		this.modelPropsEqualLocal.forEach(([prop, local]) => {

            const unwatchProp = this.$watch(prop, (val) => {
                this[local] = val;
            }, { immediate: true });

            const unwatchLocal = this.$watch(local, (val) => {
                const eventName = prop === 'value' ? 'input' : `update:${prop}`;
                if (this?.[prop] !== val) this.$emit(eventName, val);
            });

            this.unwatchIds.push(unwatchProp);
            this.unwatchIds.push(unwatchLocal);
        });

	},
    destroyed() {
        this.unwatchIds.forEach((unwatch) => {
            if (typeof unwatch === 'function') unwatch();
        });
    },
};

export { useVModel };
